import BaseModelAPI from '../BaseModelAPI';

export default class PutawayHeaderList extends BaseModelAPI {

	static entity = 'list'
	static entityName = 'putawayheader';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
